export enum ClientType {
  Pricing = 'pricing',
  Trading = 'trading',
}

export interface IClient {
  clientId: string;
  name: string;
  type: ClientType;
  enabled: boolean;
}

export interface IClientUpdate {
  clientId: IClient['clientId'];
  enabled?: boolean;
  settings?: IPricingClientSettings | ITradingClientSettings;
}

export interface IPricingClientSettings {
  securities?: string;
  symbols?: string;
  useSymbolsConjunction?: boolean;
}

export interface ITradingClientSettings {
  groups?: string;
  rejectClientRequestIfOffline?: boolean;
  securities?: string;
  symbols?: string;
  useSymbolsConjunction?: boolean;
}
